module.exports = __webpack_public_path__ + "static/spt15-6bb7e802171516d7ac4f9e4ed4114437.jpeg";